<template>
    <div class="modal fade fill-in" id="togglePayerModal" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4>Modifier le payeur désigné de cette commande</h4>
                </div>

                <div class="modal-body">
                    <p style="margin-bottom: 10px;">
                        Dans le cas d'une commande apportée par un apporteur d'affaires, vous avez la possibilité de spécifier le payeur de la commande.
                    </p>
                    <br>
                    <p>Etes-vous certain de vouloir désigner <span class="keyword">{{ newPayer }}</span> comme payeur de cette commande ?</p>
                    <br>
                    <p>
                        Attention, l’apporteur d’affaires ayant apporté la commande recevra les tickets de paiement. 
                        Merci d’en informer le client final avant paiement, si celui-ci est défini en tant que payeur.
                    </p>
                </div>

                <div class="modal-footer text-center">
                    <button type="button" @click="$emit('confirm')"
                            class="btn btn-primary btn-cons inline" data-dismiss="modal">Oui
                    </button>
                    <button type="button" class="btn btn-default btn-cons no-margin inline"
                            data-dismiss="modal" @click="$emit('cancel')">Non
                    </button>
                </div>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
</template>

<script>
    export default {
        props: ['order'],

        computed: {
            newPayer () {
                return 'customer' == this.order.payer ? "l'apporteur d'affaires" : "le client"
            },
        },

        mounted () {
            $(this.$el).modal()
        },

        beforeDestroy () {
            $(this.$el).modal('hide')
            $('body').removeClass('modal-open')
            $('.modal-backdrop').remove()
        },
    }
</script>

<style lang="scss" scoped>
    .keyword {
        vertical-align: initial !important;
        font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// client/components/Customer/OrdersTabContent/TogglePayerModal.vue